import { MenuDesignTokens } from "@primeuix/themes/types/menu";
import { primitiveColorTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const menu: MenuDesignTokens = {
    root: {
        borderRadius: primitiveLayoutTokens.borderRadius,
    },
    submenuLabel: {
        padding: "1rem 0 0 0",
    },
    item: {
        color: primitiveColorTokens.blue[850],
    },
};
